export default {"src":"/_next/static/media/bid.959eb915.svg","height":46,"width":45,"blurWidth":0,"blurHeight":0};